<template>
    <ContentCard :bg-color="bgColor" :link="url" :disabled="content.lock"
    :scheduleContent="scheduleContent" :content="content">
        <div
            class="row align-items-center"
            @click.self="handleContentClick(false)"
        >
            <div class="col ml-1" :class="content.lock ? 'disabled' : ''">
                <h4 v-if="content.lock" class="nch--content-color">
                    {{ content.translation.name }}
                </h4>
                <h4 v-else class="mb-0">
                    <a :href="url">{{ content.translation.name }}</a>
                </h4>
            </div>
            <ContentLock
                v-if="content.lock"
                class="mx-3"
                :message="content.lock_message"
                :color="color.primary"
                :icon="changeIcon"
            />
            <div v-else class="col-auto" :style="{ color: color.primary }">
                <span
                    @click.prevent.self="handleContentClick(true)"
                    v-if="content.forum"
                    :style="{ color: color.primary }"
                    class="forum"
                    :class="`mdi mdi-forum mdi-36px`"
                ></span>
                <i v-if="!hideProgress" :class="`mdi mdi-36px ${statusIcon}`"></i>
            </div>
        </div>
        <Modal
            v-model:show="modal"
            size="lg"
            bodyClasses="forum-content-body p-0"
        >
            <Forum
                :name="content.translation.name"
                :forum="content.forum"
                modal
                @close="modal = false"
                @click="$event.preventDefault()"
            />
        </Modal>
    </ContentCard>
</template>

<script>
import ContentCard from '../../Common/ContentCard';
import ContentLock from '../../ContentComponents/ContentLock';
import Modal from '../../../argon/components/Modal';
import Forum from '../../Forum';

export default {
    name: 'LessonComponent',
    components: {
        ContentCard,
        ContentLock,
        Modal,
        Forum,
    },
    props: {
        content: {
            type: Object,
            required: true,
        },
        courseId: {
            type: Number,
        },
        moduleId: {
            type: Number,
        },
        bgColor: {
            type: String,
            default: '#ececec',
        },
        parentId: Number,
        submodules: Array,
        publicLessonUrls: {
            type: Object,
            default: () => ({}),
        },
        publicUser: {
            type: Boolean,
            default: false,
        },
        hideProgress: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            url: null,
            modal: false,
        };
    },
    methods: {
        showForumHandler() {
            this.modal = true;
        },
        handleContentClick(forum) {
            if (this.content.lock) return;
            if (forum) {
                this.showForumHandler();
            } else {
                window.location.href = this.url;
            }
        },
    },
    computed: {
        formatedStartDate() {
            const startDate = new Date(this.content.lesson_publish.start_date);

            const formattedDate = startDate.toISOString().split('T')[0];

            const formattedTime = startDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedDateTimeWithSuffix = `${formattedDate} ${translation} ${formattedTime}`;

            return formattedDateTimeWithSuffix;
        },
        formatedEndDate() {
            const endDate = new Date(this.content.lesson_publish.end_date);

            const formattedEndDate = endDate.toISOString().split('T')[0];

            const formattedEndTime = endDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedEndDateTimeWithSuffix = `${formattedEndDate} ${translation} ${formattedEndTime}`;

            return formattedEndDateTimeWithSuffix;
        },
        scheduleContent() {
            if (this.content.lock_type === 'SCHEDULE') {
                if (this.content.lesson_publish &&
                    new Date(this.content.lesson_publish.start_date) > new Date() &&
                    this.content.lesson_publish.start_date != null) {
                    return `${this.$t('lesson.publish.schedule')} ${this.formatedStartDate} ` +
                        `${this.$t('common.and')} ${this.formatedEndDate}`;
                } else if (this.content.lesson_publish &&
                          new Date(this.content.lesson_publish.end_date) < new Date() &&
                          this.content.lesson_publish.end_date != null) {
                    return `${this.$t('lesson.publish.schedule_end')} ${this.formatedEndDate}`;
                }
            }

            if (this.content.lesson_publish.start_date === null && this.content.lesson_publish.end_date === null) {
                return this.$t('common.blocked');
            }

            return this.$t('common.blocked');
        },
        changeIcon() {
            if (this.content.lock_type === 'SCHEDULE') {
                const currentDate = new Date().toISOString().split('T')[0];

                if (this.content.lesson_publish.start_date > currentDate) {
                    return 'mdi mdi-calendar-clock';
                } else if (this.content.lesson_publish.end_date < currentDate) {
                    return 'mdi mdi-calendar-check';
                }
            } else {
                return 'mdi mdi-lock-outline';
            }

            return 'mdi mdi-lock-outline';
        },
        color() {
            return this.$store.getters.COLOR;
        },
        queryParam() {
            return this.submodules
                .map(sub => `submodules[]=${sub}`)
                .toString()
                .replace(/,/g, '&');
        },
        statusIcon() {
            const icons = {
                0: 'mdi-play-circle-outline',
                100: 'mdi-checkbox-marked-circle-outline',
            };
            const progress = this.content.progress || 0;
            return icons[progress] || 'mdi-clock-outline';
        },
    },
    mounted() {
        // Verificar se existe URL assinada para esta lição
        if (this.publicUser && this.publicLessonUrls && this.publicLessonUrls[this.content.id]) {
            this.url = this.publicLessonUrls[this.content.id];
            console.log(`URL assinada para lição ${this.content.id}: ${this.url}`);
        } else {
            // URL padrão
            this.url = `${this.courseId}`;
            if (this.moduleId) {
                this.url = `${this.url}/module/${this.parentId}/lesson/${this.content.id}?${this.queryParam}`;
            } else {
                this.url = `${this.url}/lesson/${this.content.id}`;
            }
        }
    },
};
</script>

<style scoped>
.forum {
    filter: grayscale(0);
    transition: all 0.2s ease-in;
}
.forum:hover {
    filter: grayscale(0.5);
}
.accordion .card-header:after {
    content: '' !important;
}
h4 {
    margin: 0;
    padding: 0;
}
</style>
